import { type Provider } from 'react';

import { type UIConfig } from '../../../types';
import { uiConfig } from './uiConfig';

export const UIConfigProvider: Provider<UIConfig> = uiConfig.Provider;
